// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"323a085d","259":"db938918","280":"2dd40711","431":"f57b756f","453":"8094c8ba","632":"72951d7f","791":"175180a5","840":"46779337","968":"016f5759"}[chunkId] + ".chunk.js";
};